
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import NotFound from '@/pages/NotFound';

// This is a placeholder component for ResellerRoutes
// In a real application, you would add your reseller routes here
const ResellerDashboard = () => (
  <div className="p-8">
    <h1 className="text-2xl font-bold mb-4">Reseller Dashboard</h1>
    <p>Welcome to the Reseller Dashboard</p>
  </div>
);

const ResellerRoutes = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<ResellerDashboard />} />
      <Route path="*" element={<Navigate to="/reseller/dashboard" replace />} />
    </Routes>
  );
};

export default ResellerRoutes;
